export { default } from './AccordionSummary';
export { default as accordionSummaryClasses } from './accordionSummaryClasses';
export * from './accordionSummaryClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/AccordionSummary/index.js
// module id = 792
// module chunks = 22